var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import API_service from "@iscr/xAppLib/providers/API_service";
import { useCallback } from "react";
const getSapStatus = ({ status, error }) => {
    if (status) {
        return status;
    }
    if (error) {
        return "check_failed";
    }
    return "checking";
};
export const useCheckSapStatus = () => {
    const { data, error, fn } = useAsync({
        immediate: true,
        keep: false,
        fn: () => __awaiter(void 0, void 0, void 0, function* () { return API_service.load_data("admin/docpay/invoices/sap-status"); }),
    });
    // Resolves with the status the check came back with, so a caller can act on it straight away
    // (e.g. re-checking right before generating invoices) instead of waiting for the re-render.
    const recheck = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            return getSapStatus({ status: (_a = (yield fn())) === null || _a === void 0 ? void 0 : _a.status });
        }
        catch (err) {
            return getSapStatus({ error: err });
        }
    }), [fn]);
    return { status: getSapStatus({ status: data === null || data === void 0 ? void 0 : data.status, error }), recheck };
};
